import { Exclude, Transform, Type } from 'class-transformer';

import { dateTransform } from '../utils/helper';
import { PeriodicService } from './periodicservice.model';

export class PeriodicItem {
	id?: number;
	dayoftheweek!: DayOfTheWeek;
	@Transform(dateTransform)
	startdate?: Date;
	@Transform(dateTransform)
	stopdate?: Date;
	serviceid?: number;
	andataritorno?: number = 0;

	@Exclude({ toPlainOnly: true })
	@Type(() => PeriodicService)
	service?: PeriodicService;
}

export enum PeriodicItemDirection {
	ONEWAY = 0,
	ROUNDTRIP = 1,
}

export class PeriodicItemWeek {
	1: boolean = false;
	2: boolean = false;
	3: boolean = false;
	4: boolean = false;
	5: boolean = false;
	6: boolean = false;
	7: boolean = false;
}

export enum DayOfTheWeek {
	MONDAY = 2,
	TUESDAY = 3,
	WEDNESDAY = 4,
	THURSDAY = 5,
	FRIDAY = 6,
	SATURDAY = 7,
	SUNDAY = 1,
}